// components/AirportSelect.js
import React, {useEffect, useRef} from "react";
import { Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {actions as airportsActions} from "../../../store/reducers/AirportsReducer";

const { Option } = Select;

const AirportSelect = ({ value, onChange, placeholder = "Select Airport" }) => {

  const dispatch = useDispatch();
  const { data, isLoading } = useSelector((state) => state.airports);

  // useEffect(() => {
  //   dispatch(airportsActions.onRequest({}));
  // }, [dispatch]);

  const searchTimeout = useRef(null);
  const handleSearch = (value) => {
    clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      dispatch(airportsActions.onRequest({ filter: value }));
    }, 300);
  };

  // const airports = data || [];
  const airports = Array.isArray(data) ? data : [];

  console.log("Redux airports:", data);
  console.log("Current value:", value);

  return (
    <Select
      showSearch
      labelInValue
      value={value}
      placeholder={placeholder}
      onChange={(val) => onChange(val?.value)} // extract just value
      onSearch={handleSearch}
      filterOption={false}
      notFoundContent={isLoading ? <Spin size="small" /> : null}
      style={{ width: 160 }}
    >
      {airports?.map((airport) => (
        <Option key={airport.iata} value={`${airport.city} - ${airport.iata}`}>
          {airport.city} - {airport.iata}
        </Option>
      ))}
    </Select>
  );
};

export default AirportSelect;
